import { MainContents } from '@/components/MainContents';
import Tabs from '@/components/Tabs';
import { useState } from 'react';
import { CandidateImportRequestsUploadTab } from '../components/CandidateImportRequestsUploadTab';
import { CandidateImportRequestsPresetsTab } from '../components/CandidateImportRequestsPresetsTab';
import { CandidateImportRequestsHistoryTab } from '../components/CandidateImportRequestsHistoryTab';

type TabKey = 'upload' | 'presets' | 'history';

export function CandidateImportRequestsNewTemplate() {
  const [currentTab, setCurrentTab] = useState<TabKey>('upload');

  const tabItems = [
    {
      label: 'CSVアップロード',
      current: currentTab === 'upload',
      onClick: () => setCurrentTab('upload'),
    },
    {
      label: '取り込みプリセット',
      current: currentTab === 'presets',
      onClick: () => setCurrentTab('presets'),
    },
    {
      label: '取り込み履歴',
      current: currentTab === 'history',
      onClick: () => setCurrentTab('history'),
    },
  ];

  return (
    <MainContents>
      <div className="flex flex-col gap-md">
        {/* タブナビゲーション */}
        <Tabs items={tabItems} />

        {/* タブコンテンツ */}
        <div className="rounded-sm bg-white p-lg shadow-layer1">
          {currentTab === 'upload' && <CandidateImportRequestsUploadTab />}
          {currentTab === 'presets' && <CandidateImportRequestsPresetsTab />}
          {currentTab === 'history' && <CandidateImportRequestsHistoryTab />}
        </div>
      </div>
    </MainContents>
  );
}
